/* eslint-disable max-statements */
import React from "react";
import PropTypes from "prop-types";
import styles from "./styles.css";
import priceFormatter from "../../../utils/helpers/price-formatter";
import { getParticularDay, getMonth } from "../../../utils/helpers/get-day-from-date";
import getSuffix from "../../../utils/helpers/get-suffix";
import PdfIcon from "./images/pdf.svg";
import SemiModal from "../semi-modal";
import CloseButton from "../../shared/icon-cross";
import { NUMBER } from "../../../constants/app-constants";

const PostInspectionDiyChallanList = ({
    priceBreakup,
    onClose,
    onClick = () => {}
}) => {
    const { deductions } = priceBreakup || {};
    const { totalChallanAmount, totalChallanCount, challanDetails } = deductions || {};
    const { clearedChallanList = [], pendingChallanList = []} = challanDetails || {};
    const pendingChallanTitle = pendingChallanList.length > NUMBER.ONE ? "Pending challans" : "Pending challan";

    const title = clearedChallanList.length ? "Challan clearance status" : pendingChallanTitle;

    const parseDateString = (challanDate) => {
        const date = new Date(challanDate);

        return `
            ${getParticularDay(date)} ${getMonth(date, true)} ${date.getFullYear()}
        `;
    };

    const handleChallanClick = ({challanName, fileType, challanDoc, event, isPdf}) => {
        if (!isPdf && event.target.dataset.error === "true") return;
        onClick({challanName, fileType, challanDoc});
    };

    const renderChallanList = (heading, list) => {
        return (
            <React.Fragment>
                <p styleName={"styles.heading"}>{heading}</p>
                {
                    list.map(({challanName, challanDoc, isPdf, closedAt, offenceDate, amount, isCleared, fileType}, index) => (
                        <div key={index} styleName={`styles.challanList ${isCleared ? "" : "styles.pendingChallanWrapper"}`}>
                            <div styleName={"styles.documentCover"}>
                                <img
                                    styleName={"styles.logo"}
                                    src={isPdf ? PdfIcon : challanDoc} alt={challanName}
                                    onClick={(event) => {handleChallanClick({challanName, fileType, challanDoc, event, isPdf});}}
                                    data-error={false} // if true, will not open the image expanded view
                                    onError={(e) => {
                                        if (e.target.src !== PdfIcon) {
                                            e.target.src = PdfIcon;
                                            e.target.dataset.error = true;
                                        }
                                    }}
                                />
                                <div styleName={"styles.challanText"}>
                                    <h5>{challanName}</h5>
                                    <span>
                                        {parseDateString(isCleared ? closedAt : offenceDate)}
                                    </span>
                                </div>
                            </div>
                            <p styleName={`${isCleared ? "styles.clearedChallan" : "styles.pendingChallan"}`}>
                                ₹{priceFormatter(amount)}
                            </p>
                        </div>
                    ))
                }
            </React.Fragment>
        );
    };

    return (
        <SemiModal onOverlayClick={onClose}>
            <div styleName={"styles.mainWrapperPopup"}>
                <div styleName={"styles.mainWrapper"}>
                    <div styleName={"styles.clearanceStatus"}>
                        <h4>{title}</h4>
                        <CloseButton type={"black"} onClickHandler={onClose} />
                    </div>
                    <div styleName={"styles.challansStatusWrapper"}>
                        <p styleName={"styles.totalChalan"}>Total ({getSuffix(totalChallanCount, "challan")}) <span>₹{priceFormatter(totalChallanAmount)}</span> </p>
                        { !!clearedChallanList.length && renderChallanList("Cleared", clearedChallanList) }
                        { !!pendingChallanList.length && renderChallanList("Will be cleared before RC transfer", pendingChallanList) }
                    </div>
                </div>
            </div>

        </SemiModal>
    );
};

PostInspectionDiyChallanList.propTypes = {
    priceBreakup: PropTypes.object,
    onClose: PropTypes.func,
    onClick: PropTypes.func
};

export default PostInspectionDiyChallanList;
